import styled from "styled-components";

export const ActiveRoutePage = styled.div`
  width: 100%;
`;
